const dataCenter = localStorage.getItem('data-center') || ''

//全局数据中心变量
export default {
  state: {
    dataCenter: dataCenter || 1,
    list: [
      { zh: '美西数据中心', en: 'Western US', value: 2 },
      { zh: '美东数据中心', en: 'Eastern US', value: 5 },
      { zh: '中欧数据中心', en: 'Central Europe', value: 3 },
      { zh: '西欧数据中心', en: 'Western Europe', value: 6 },
      { zh: '印度数据中心', en: 'India', value: 4 },
      { zh: '中国数据中心', en: 'China', value: 1 }
    ]
  },

  mutations: {
    //保存数据中心
    saveDataCenter(state, value) {
      state.dataCenter = value
      localStorage.setItem('data-center', value)
    }
  }
}
